import { Component, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {CoilResponse} from '../../model/coil-response';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-schedule-line-performance-coil-output',
    templateUrl: './schedule-line-performance-coil-output.component.html',
    styleUrls: ['./schedule-line-performance-coil-output.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DecimalPipe]
})
export class ScheduleLinePerformanceCoilOutputComponent implements OnChanges {

  readonly fieldLabel = input.required<string>();
  readonly response = input.required<CoilResponse>();
  readonly isMetric = input.required<boolean>();
  readonly isHeat = input.required<boolean>();
  readonly isSureflow = input<boolean>(undefined!);

  constructor() {
  }

  ngOnChanges() {
  }

  getCapacityUnits(): string {
    return UnitConversionUtils.getCapacityUnits(this.isMetric());
  }

  getTemperatureUnits(): string {
    return UnitConversionUtils.getTemperatureUnits(this.isMetric());
  }

  getFlowRateUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.isMetric());
  }

  getPressureDropUnits(): string {
    return UnitConversionUtils.getPressureUnits(this.isMetric());
  }

}
